<template>
  <v-expansion-panel
    ref="panel"
    @change="onChange"
  >
    <v-expansion-panel-header
      id="post-processings-results-header"
      ripple
    >
      <v-row>
        <v-col cols="12">
          <span
            :class="['body-1', {
            'post-processing-active--text': postProcessingsIsActive,
            'grey--text text--darken-1': !postProcessingsIsActive
          }]"
          >Resultados das Análises Agronômicas</span>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content
      eager
    >
      <v-skeleton-loader
        v-if="isLoading"
        :loading="isLoading"
        type="article"
        class="mx-auto flex-fill"
        width="100%"
      />
      <v-scale-transition>
        <v-container
          v-if="!isLoading"
          fluid
          class="px-0 pb-0"
        >
          <v-row
            class="ma-0"
          >
            <v-expansion-panels
              multiple
              focusable
            >
              <post-processing-result-sub-panel
                v-for="pp in this.fieldsPostProcessings"
                :key="pp['id_field_post_processing']"
                :field-post-processing="pp"
              />
            </v-expansion-panels>
          </v-row>
        </v-container>
      </v-scale-transition>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
  import {listFieldsPostProcessings} from "../../../../api/api-project"
  import {isEmpty} from "lodash/lang"
  import PostProcessingResultSubPanel from "./PostProcessingResultSubPanel"
  import {FloatingCardsEventBus} from "../../../../helpers/mapview/events"
  import {findIndex} from "lodash/array"
  import {find, forEach} from "lodash/collection"
  import {FEATURE_GROUPS} from "../../../../helpers/leaflet/constants"
  import {LAYER_COLORS} from "../../../../helpers/mapview/constants"
  import {mapActions} from "vuex"
  import {
    SET_IS_POST_PROCESSING_RESULTS_STATE,
  } from "../../../../store/modules/mapview"
  import {PostProcessingsResultsEventBus} from "../../../../helpers/post-processings/events"

  const _Map = Symbol.for("_Map")
  const _Processing = Symbol.for("_Processing")
  const _Fields = Symbol.for("_Fields")

  export default {
    name: "PostProcessingsResultsPanel",
    inject: {_Map, _Processing},
    provide() {
      return {
        [_Fields]: () => this.fields
      }
    },
    components: {PostProcessingResultSubPanel},
    data: () => ({
      isLoading: true,
      fieldsPostProcessings: [],
      fields: [],

      postProcessingsIsActive: false,
    }),
    methods: {
      onAdd(item) {
        if (find(this.fields, ["field.id_field", item["field"]["id_field"]])) {
          this.onRemove(item)
          return
        }

        item["layer"].setPostProcessingResultsStyle()
        this.fields.push(item)
      },
      onRemove(item) {
        const idx = findIndex(this.fields, ["field.id_field", item["field"]["id_field"]])
        this.fields.splice(idx, 1)
        item["layer"].clearStyle()
      },
      onActive() {
        this.$nextTick()
          .then(() => {
            FloatingCardsEventBus.$emit("close")
            forEach(this.fields, item => item["layer"].setPostProcessingResultsStyle())
          })
      },
      onChange() {
        this.setIsPostProcessingResultsState(!this.$refs["panel"].isActive)
        if (!this.$refs["panel"].isActive) {
          this.postProcessingsIsActive = true
          this.onActive()
        } else {
          this.postProcessingsIsActive = false
          this.Map.featureGroups[FEATURE_GROUPS.FEATURES].setStyle({
            fillColor: LAYER_COLORS.DEFAULT,
            color: LAYER_COLORS.DEFAULT
          })
        }
      },
      onCreated() {
        listFieldsPostProcessings(this.$apiAuth.getAuthToken(), this.Processing["id_processing"])
          .then(res => {
            if (!res) return
            if (!res.data) return
            if (!res.data.data) return
            const fieldsPostProcessings = res.data.data
            if (isEmpty(fieldsPostProcessings)) return
            this.fieldsPostProcessings = fieldsPostProcessings
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      ...mapActions({
        setIsPostProcessingResultsState: SET_IS_POST_PROCESSING_RESULTS_STATE
      })
    },
    computed: {
      Map() {
        return this._Map()
      },
      Processing() {
        return this._Processing()
      }
    },
    created() {
      PostProcessingsResultsEventBus.$on("add", this.onAdd)
      PostProcessingsResultsEventBus.$on("remove", this.onRemove)
      this.onCreated()
    }

  }
</script>

<style scoped lang="scss">
  ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 12px 12px;
  }

  .post-processing-active--text {
    color: #93be20 !important;
  }
</style>
